var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBooking2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.728 104.02C134.692 109.99 143.005 137.307 143.909 140.382C144.27 141.829 143.547 143.457 141.921 143.819C141.74 143.819 141.379 144 141.198 144C141.017 144 140.656 144 140.475 143.819C137.403 142.915 110.114 134.593 104.151 128.623C97.2832 121.749 97.2832 110.714 104.151 104.02C110.837 97.3266 121.861 97.3266 128.728 104.02Z",
    fill: "url(#paint0_linear_203_521)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83403 5.07517C2.19417 3.45461 3.45461 2.37423 5.07516 1.83404C12.0976 0.393543 19.4802 -0.146645 26.6827 0.033418C53.6921 0.033418 69.8977 14.4384 81.9619 33.5251H109.151C113.833 33.7051 117.974 36.4061 120.315 40.3674L133.28 66.2965C133.64 67.1968 133.82 68.0971 134 69.1775C134 72.5986 131.119 75.4797 127.698 75.4797H100.508L106.27 81.2416C109.511 84.4828 109.511 89.7046 106.27 93.1258L92.9457 106.45C89.7046 109.692 84.4828 109.692 81.0616 106.45L75.1195 100.508V127.698C75.1195 131.119 72.4186 134 68.8173 134C67.917 134 67.0167 133.82 66.1164 133.46L40.3674 120.495C36.226 118.154 33.7051 114.013 33.5251 109.331V81.7818C14.4384 69.7177 0.0334167 53.512 0.0334167 26.6827C-0.146652 19.4802 0.393539 12.2777 1.83403 5.07517ZM33.5251 43.9687C39.2871 43.9687 43.9687 39.2871 43.9687 33.5251C43.9687 27.7631 39.2871 23.0814 33.5251 23.0814C27.7631 23.0814 23.0814 27.7631 23.0814 33.5251C23.0814 39.2871 27.7631 43.9687 33.5251 43.9687Z",
    fill: "url(#paint1_linear_203_521)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_203_521",
    x1: 142.743,
    y1: 144,
    x2: 78.3499,
    y2: 112.284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39",
    stopOpacity: 0.69
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_203_521",
    x1: 274.351,
    y1: 280.14,
    x2: -58.4902,
    y2: 103.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28125,
    stopColor: "#F87F39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "#F05A5A",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#EB426F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF1995"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking2);
export default __webpack_public_path__ + "static/media/booking2.99c5b6ba4fec70b6a837985e73b9859f.svg";
export { ForwardRef as ReactComponent };